import React, { useEffect, useRef, useState } from 'react';

const initData = {
  workorderid: 0,
  firm: '',
  standarD_ID: '',
  eqno: '',
  partid: 0,
  wtname: '',
  arinvT_ID: '',
  materiaL_ID: '',
  cycle: '',
  cntR_TYPE: '',
  operator: '',
  certifieD_FIRST_NAME: '',
  certifieD_LAST_NAME: '',
  certificatioN_FILENAME: '',
  certificatioN_REVISION: '',
  certificatioN_DATE: new Date().toISOString().split('T')[0],
  cycletm: '',
  itemnumber: '',
  itemdescription: '',
  quantity: 0,
  palletQuantity: 0,
  materialBatchNO: '',
  cycleS_REQ: '',
  mfG_TYPE: '',
  createdBy: '',
  createdOn: new Date().toISOString().split('T')[0],
  updatedOn: new Date().toISOString().split('T')[0],
  locationId: 0,
  note1: '',
  note2: '',
};

const WorkTicketAddEditForm = ({ data, onChanges, onFileUpload, id, formRef }) => {
  const [formData, setFormData] = useState(data ? data : initData);

  const updateFormField = (fieldName, value) => {
    setFormData(prevData => ({
      ...prevData,
      [fieldName]: value,
    }));
    onChanges({ ...formData, [fieldName]: value });
  };

  return (
    <>
      <div className="table-top">
        <div className="col-lg-2 col-md-2 col-sm-6">
          <label className="form-label" htmlFor="workorderid">
            Work Order ID
          </label>
          <input
            type="text"
            value={formData.workorderid}
            onChange={e => updateFormField('workorderid', e.target.value)}
            className="form-control"
            placeholder=""
            id="workorderid"
          />
        </div>
      </div>

      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="firm">
              Company/Firm <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              value={formData.firm}
              onChange={e => updateFormField('firm', e.target.value)}
              className="form-control"
              placeholder=""
              id="firm"
            />
            <div className="invalid-feedback">Please provide a valid Company Name or Firm Name</div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="standarD_ID">
              Standard ID
            </label>
            <input
              type="text"
              value={formData.standarD_ID}
              onChange={e => updateFormField('standarD_ID', e.target.value)}
              className="form-control"
              placeholder=""
              id="standarD_ID"
            />
          </div>
        </div>
      </div>
      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="eqno">
              Equipment Number
            </label>
            <input
              type="text"
              value={formData.eqno}
              onChange={e => updateFormField('eqno', e.target.value)}
              className="form-control"
              placeholder=""
              id="eqno"
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="partid">
              Part ID
            </label>
            <input
              type="text"
              value={formData.partid}
              onChange={e => updateFormField('partid', e.target.value)}
              className="form-control"
              placeholder=""
              id="partid"
            />
          </div>
        </div>
      </div>

      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="wtname">
              Work Ticket Name
            </label>
            <input
              type="text"
              value={formData.wtname}
              onChange={e => updateFormField('wtname', e.target.value)}
              className="form-control"
              placeholder=""
              id="wtname"
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="arinvT_ID">
              Inventory ID
            </label>
            <input
              type="text"
              value={formData.arinvT_ID}
              onChange={e => updateFormField('arinvT_ID', e.target.value)}
              className="form-control"
              placeholder=""
              id="arinvT_ID"
            />
          </div>
        </div>
      </div>

      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="materiaL_ID">
              Material ID
            </label>
            <input
              type="text"
              value={formData.materiaL_ID}
              onChange={e => updateFormField('materiaL_ID', e.target.value)}
              className="form-control"
              placeholder=""
              id="materiaL_ID"
            />
          </div>

          <div className="input-blocks">
            <label className="form-label" htmlFor="cycle">
              Cycle
            </label>
            <input
              type="text"
              value={formData.cycle}
              onChange={e => updateFormField('cycle', e.target.value)}
              className="form-control"
              placeholder=""
              id="cycle"
            />
          </div>

          <div className="input-blocks">
            <label className="form-label" htmlFor="cntR_TYPE">
              Container Type
            </label>
            <input
              type="text"
              value={formData.cntR_TYPE}
              onChange={e => updateFormField('cntR_TYPE', e.target.value)}
              className="form-control"
              placeholder=""
              id="cntR_TYPE"
            />
          </div>

          <div className="input-blocks">
            <label className="form-label" htmlFor="operator">
              Operator
            </label>
            <input
              type="text"
              value={formData.operator}
              onChange={e => updateFormField('operator', e.target.value)}
              className="form-control"
              placeholder=""
              id="operator"
            />
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12">
          <h5 className="header-five">Certification Details</h5>
          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="certifieD_FIRST_NAME">
                  First Name
                </label>
                <input
                  type="text"
                  value={formData.certifieD_FIRST_NAME}
                  onChange={e => updateFormField('certifieD_FIRST_NAME', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="certifieD_FIRST_NAME"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="certifieD_LAST_NAME">
                  Last Name
                </label>
                <input
                  type="text"
                  value={formData.certifieD_LAST_NAME}
                  onChange={e => updateFormField('certifieD_LAST_NAME', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="certifieD_LAST_NAME"
                />
              </div>
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="certificatioN_FILENAME">
                  File Name
                </label>
                <input
                  type="text"
                  value={formData.certificatioN_FILENAME}
                  onChange={e => updateFormField('certificatioN_FILENAME', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="certificatioN_FILENAME"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="certificatioN_REVISION">
                  Revision
                </label>
                <input
                  type="text"
                  value={formData.certificatioN_REVISION}
                  onChange={e => updateFormField('certificatioN_REVISION', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="certificatioN_REVISION"
                />
              </div>
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="certificatioN_DATE">
                  Certification Date
                </label>
                <input
                  type="date"
                  value={formData.certificatioN_DATE}
                  onChange={e => updateFormField('certificatioN_DATE', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="certificatioN_DATE"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks">
            <label className="form-label" htmlFor="cycletm">
              Cycle Time
            </label>
            <input
              type="text"
              value={formData.cycletm}
              onChange={e => updateFormField('cycletm', e.target.value)}
              className="form-control"
              placeholder=""
              id="cycletm"
            />
          </div>

          <div className="input-blocks">
            <label className="form-label" htmlFor="itemnumber">
              Item Number
            </label>
            <input
              type="text"
              value={formData.itemnumber}
              onChange={e => updateFormField('itemnumber', e.target.value)}
              className="form-control"
              placeholder=""
              id="itemnumber"
            />
          </div>

          <div className="input-blocks">
            <label className="form-label" htmlFor="itemDescription">
              Item Description
            </label>
            <input
              type="text"
              value={formData.itemdescription}
              onChange={e => updateFormField('itemdescription', e.target.value)}
              className="form-control"
              placeholder=""
              id="itemdescription"
            />
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12">
          <h5 className="header-five">Quantity Information</h5>
          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="quantity">
                  Quantity
                </label>
                <input
                  type="text"
                  value={formData.quantity}
                  onChange={e => updateFormField('quantity', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="quantity"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="palletQuantity">
                  Pallet Quantity
                </label>
                <input
                  type="text"
                  value={formData.palletQuantity}
                  onChange={e => updateFormField('palletQuantity', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="palletQuantity"
                />
              </div>
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks mt-3">
                <label className="form-label" htmlFor="materialBatchNO">
                  Material Batch Number
                </label>
                <input
                  type="text"
                  value={formData.materialBatchNO}
                  onChange={e => updateFormField('materialBatchNO', e.target.value)}
                  className="form-control"
                  placeholder=""
                  id="materialBatchNO"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row m-2">
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks mt-3">
            <label className="form-label" htmlFor="cycleS_REQ">
              Cycle Required
            </label>
            <input
              type="text"
              value={formData.cycleS_REQ}
              onChange={e => updateFormField('cycleS_REQ', e.target.value)}
              className="form-control"
              placeholder=""
              id="cycleS_REQ"
            />
          </div>
          <div className="input-blocks mt-3">
            <label className="form-label" htmlFor="manufacturingType">
              Manufacturing Type
            </label>
            <input
              type="text"
              value={formData.mfG_TYPE}
              onChange={e => updateFormField('mfG_TYPE', e.target.value)}
              className="form-control"
              placeholder=""
              id="mfG_TYPE"
            />
          </div>
          <div>
            <div className="d-grid">
              <label className="fw-bold">
                Created By: <span className="">{formData.createdBy}</span>
              </label>
              <label className="fw-bold">
                Created On: <span className="">{formData.createdOn}</span>
              </label>
              <label className="fw-bold">
                Last Updated: <span className="">{formData.updatedOn}</span>
              </label>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12">
          <div className="input-blocks mt-3">
            <label className="form-label" htmlFor="locationId">
              Location ID
            </label>
            <input
              type="text"
              value={formData.locationId}
              onChange={e => updateFormField('locationId', e.target.value)}
              className="form-control"
              placeholder=""
              id="locationId"
            />
          </div>

          <h5 className="header-five">Notes</h5>

          <div className="input-blocks mt-3">
            <label className="form-label" htmlFor="note1">
              Note 1
            </label>
            <textarea
              rows={5}
              cols={5}
              className="form-control"
              placeholder="Note 1"
              defaultValue={''}
              value={formData.note1}
              onChange={e => updateFormField('note1', e.target.value)}
            />
          </div>
          <div className="input-blocks mt-3">
            <label className="form-label" htmlFor="note2">
              Note 2
            </label>
            <textarea
              rows={5}
              cols={5}
              className="form-control"
              placeholder="Note 2"
              defaultValue={''}
              value={formData.note2}
              onChange={e => updateFormField('note2', e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkTicketAddEditForm;
